import { render, staticRenderFns } from "./ProductOverviewPage.vue?vue&type=template&id=384a5a6c"
import script from "./ProductOverviewPage.vue?vue&type=script&lang=js"
export * from "./ProductOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports